/* tslint:disable */
/* eslint-disable */
/**
 * Alobacsi API
 * The Alobacsi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignUpDto
 */
export interface SignUpDto {
    /**
     * 
     * @type {string}
     * @memberof SignUpDto
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof SignUpDto
     */
    password: string;
    /**
     * 
     * @type {boolean}
     * @memberof SignUpDto
     */
    resendOtp: boolean;
}

/**
 * Check if a given object implements the SignUpDto interface.
 */
export function instanceOfSignUpDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "phone" in value;
    isInstance = isInstance && "password" in value;
    isInstance = isInstance && "resendOtp" in value;

    return isInstance;
}

export function SignUpDtoFromJSON(json: any): SignUpDto {
    return SignUpDtoFromJSONTyped(json, false);
}

export function SignUpDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignUpDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phone': json['phone'],
        'password': json['password'],
        'resendOtp': json['resendOtp'],
    };
}

export function SignUpDtoToJSON(value?: SignUpDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phone': value.phone,
        'password': value.password,
        'resendOtp': value.resendOtp,
    };
}

